import { getWhatsAppUrl, trackWhatsAppClick, waMessages } from "@/lib/whatsapp";

export default function WhatsAppFloating() {
  return (
    <a
      href={getWhatsAppUrl(waMessages.general)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp'tan yazın"
      onClick={() =>
        trackWhatsAppClick({
          source_section: "floating_button",
          page_path: window.location.pathname,
        })
      }
      className="fixed bottom-6 right-6 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white transition-colors hover:bg-[#1ebe5b] md:flex"
    >
      <i className="ri-whatsapp-line text-2xl" aria-hidden="true"></i>
    </a>
  );
}